module.exports = __webpack_public_path__ + "static/media/zoomy6.6a2f7ff7.jpg";